// extracted by mini-css-extract-plugin
module.exports = {"body":"PreviewEmailComm_body__vuyto"};